import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CreateReportViewConfigurationRequest, ExportReportViewConfigurationResponse, ExportReportViewConfigurationWithDependenciesResponse, ExportReportViewFromSelectionRequest, GetReportViewConfigurationRequest, GetReportViewConfigurationResponse, ImportReportViewConfigurationRequest, ReportViewConfigurationResponse, ValidateExportReportViewsResponse, ValidateImportReportViewsResponse } from '../../models/report-view.models';
import { ExportConfigurationsWithDependenciesModel } from '../../models/configuration-common.models';

@Injectable({
  providedIn: 'root'
})
export class ReportViewConfigurationService {
  private api = `${environment.baseV5ApiUri}/ReportViewConfiguration`;
  constructor(private http: HttpClient) { }

  getAll(request: GetReportViewConfigurationRequest): Observable<GetReportViewConfigurationResponse> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(request)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, value.toString());
      }
    }

    return this.http.get<GetReportViewConfigurationResponse>(`${this.api}`, { params });
  }

  create(request: CreateReportViewConfigurationRequest): Observable<any> {
    return this.http.post<GetReportViewConfigurationResponse>(`${this.api}`, request);
  }

  getById(id: string): Observable<ReportViewConfigurationResponse> {
    return this.http.get<ReportViewConfigurationResponse>(`${this.api}/${id}`);
  }

  getByName(name: string): Observable<ReportViewConfigurationResponse> {
    return this.http.get<ReportViewConfigurationResponse>(`${this.api}/by-name/${name}`);
  }

  update(id: string, request: CreateReportViewConfigurationRequest): Observable<void> {
    return this.http.put<void>(`${this.api}/${id}`, request);
  }

  delete(id: string) {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  export(ids: string[]): Observable<ExportConfigurationsWithDependenciesModel> {
    return this.http.post<ExportConfigurationsWithDependenciesModel>(`${this.api}/export`, ids);
  }

  exportWithDependencies(ids: string[]): Observable<ExportConfigurationsWithDependenciesModel> {
    return this.http.post<ExportConfigurationsWithDependenciesModel>(`${this.api}/export-with-dependencies`, ids);
  }

  validateExport(ids: string[]): Observable<ValidateExportReportViewsResponse> {
    return this.http.post<ValidateExportReportViewsResponse>(`${this.api}/validate-export`, ids);
  }

  exportFromSelection(request: ExportReportViewFromSelectionRequest): Observable<ExportConfigurationsWithDependenciesModel> {
    return this.http.post<ExportConfigurationsWithDependenciesModel>(`${this.api}/export-from-selection`, request);
  }

  validateImport(file: File): Observable<ValidateImportReportViewsResponse> {
    const formData = new FormData();
    formData.append('json', file);

    return this.http.post<ValidateImportReportViewsResponse>(`${this.api}/validate-import`, formData);
  }

  importEntities(request: ImportReportViewConfigurationRequest): Observable<void> {
    return this.http.post<void>(`${this.api}/import`, request);
  }

  bulkDelete(ids: string[]): Observable<void> {
    return this.http.delete<void>(`${this.api}/bulk-delete`, { body: ids });
  }
}
